import React from 'react';
import Checkbox from '../../../components/Checkbox/Checkbox';
import Flag from '../../../components/Flag/Flag';
import s from '../WatchtowerPage.module.scss';
import classNames from 'classnames';

const FilterCheckboxList = ({
    title,
    items,
    selectedItems = [],
    onItemToggle,
    showFlags = false,
    showColors = false,
    modifiers = [],
    availableItems = null,
}) => {
    const selectedItemsArray = Array.isArray(selectedItems)
        ? selectedItems
        : [];

    const handleToggle = (id, isDisabled) => {
        if (isDisabled) return;

        onItemToggle((prevSelectedItems) => {
            const currentItems = Array.isArray(prevSelectedItems)
                ? prevSelectedItems
                : [];
            return currentItems.includes(id)
                ? currentItems.filter((item) => item !== id)
                : [...currentItems, id];
        });
    };

    if (!Array.isArray(items)) {
        return null;
    }

    const classes = classNames(
        s.CheckboxList,
        modifiers.map((modifier) => s[`CheckboxList--${modifier}`])
    );

    return (
        <ul className={classes}>
            {items.map(({ id, label, color }, index) => {
                const isSelected = selectedItemsArray.includes(id);
                const isDisabled = availableItems
                    ? !availableItems.has(id) && !isSelected
                    : false;

                return (
                    <li
                        key={id}
                        title={label}
                        className={classNames(s.CheckboxItem, {
                            [s['CheckboxItem--Disabled']]: isDisabled,
                            [s['CheckboxItem--First']]: index === 0,
                            [s['CheckboxItem--Last']]:
                                index === items.length - 1,
                        })}>
                        {showColors && (
                            <div className={s.CheckboxColorWrapper}>
                                <div
                                    className={s.CheckboxColor}
                                    style={{ backgroundColor: color }}
                                />
                            </div>
                        )}
                        {showFlags && (
                            <div className={s.CheckboxIconWrapper}>
                                <Flag countryCode={id} width="2.4rem" />
                            </div>
                        )}
                        <span className={s.CheckboxLabel} title={label}>
                            {label}
                        </span>
                        <div className={s.CheckboxWrapper}>
                            <Checkbox
                                modifier="Alternative"
                                label={label}
                                value={id}
                                checked={isSelected}
                                disabled={isDisabled}
                                onChange={() => handleToggle(id, isDisabled)}
                            />
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

export default FilterCheckboxList;
